module.exports = __webpack_public_path__ + "static/media/time_to_repeat_ru.41044a89.jpg";